<h2 mat-dialog-title><b>{{titulo}}</b></h2>
<div mat-dialog-content>
    <p>
        <span [innerHtml]="texto"></span>
    </p>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Fechar</button>
</div>